export const DataScoringAssociationSelector = ({
  dataScoringAssociations: { uploadDataSummary }
}) => uploadDataSummary;

export const ViewGroupDetailsSelector = ({
  dataScoringAssociations: { dataSubGroupDetails }
}) => dataSubGroupDetails;
